import { gql } from 'graphql-tag';

export const notificationTemplateMetadataListQuery = gql`
  query NotificationTemplateMetadataList {
    notificationTemplateMetadataList {
      template_name
      title
      description
    }
  }
`;

export const upsertNotificationTemplateMetadataMutation = gql`
  mutation UpsertNotificationTemplateMetadata($template_name: String!, $title: String, $description: String) {
    upsertNotificationTemplateMetadata(template_name: $template_name, title: $title, description: $description) {
      template_name
      title
      description
    }
  }
`;
